import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

const ScoutingCenterLayout = () => {
  return (
    <Wrapper>
      <ProfilePageHeader />
      <Outlet />
    </Wrapper>
  );
};

export default ScoutingCenterLayout;
